import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {applicantPortfoliosUrl} from "../../constants/api/endpoints";

interface GetPortfoliosParams {
  user_id: string
}

export const useQueryApplicantPortfolios = (params: GetPortfoliosParams) => {
  const {
    user_id
  } = params;

  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(applicantPortfoliosUrl, {
      params: {
        user_id
      }
    })
      .then(response => response?.data?.submitted_portfolios ?? response);
  }

  return useQuery({
    queryKey: ['portfolios-list', user_id],
    queryFn: handleRequest
  })
}
